import React from 'react';
import PropTypes from 'prop-types';
import FloatingLabelInput from './FloatingLabelInput';
import { Dropdown } from 'semantic-ui-react';
import styles from './FloatingLabelInput.scss';
import styleVariables from '../../variables';

export default class FloatingLabelSelect extends React.Component {
  static propTypes = {
    inline: PropTypes.oneOf(['last', true, false]),
    className: PropTypes.string,
    onChange: PropTypes.func,
    submitted: PropTypes.bool,
    value: PropTypes.string,
    style: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    validations: PropTypes.string,
    validationError: PropTypes.string,
    validationErrors: PropTypes.string,
    required: PropTypes.bool,
    width: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillMount() {
    this.updateWindowDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ window: { width: window.innerWidth, height: window.innerHeight } });
  }

  render() {
    const {
      inline,
      label,
      name,
      onChange,
      placeholder,
      className,
      value,
      validations,
      validationError,
      validationErrors,
      required,
      style,
      submitted,
      width,
      ...rest
    } = this.props;

    const selectField =
      this.state.window.width < styleVariables.tabletBreakpoint
        ? <select className={styles.nativeSelect}>
          {this.props.options.map((option, idx) =>
            <option value={option.value} key={idx}>
              {option.text}
            </option>
          )}
        </select>
        : <Dropdown
          selection
          floating
          style={Object.assign(
              {},
            {
              border: 0,
              lineHeight: '1.4285em',
              padding: 'calc(0.25rem - 1px) 2rem calc(0.25rem - 1px) 0',
              margin: 0,
              boxShadow: 'none',
              minHeight: 'auto'
            },
              this.props.style
            )}
          value={value}
          {...rest}
        />;
    return (
      <FloatingLabelInput
        className={className}
        label={label}
        name={name}
        value={value}
        type='select'
        onChange={onChange}
        validations={validations}
        validationError={validationError}
        validationErrors={validationErrors}
        required={required}
        width={width}
        inline={inline}
        style={style}
        submitted={submitted}
        placeholder={placeholder}
      >
        {selectField}
      </FloatingLabelInput>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Elements/FloatingLabelInput/FloatingLabelSelect.js